import { render, staticRenderFns } from "./VisitorStatisticsList.vue?vue&type=template&id=236bd862&scoped=true"
import script from "./VisitorStatisticsList.vue?vue&type=script&lang=js"
export * from "./VisitorStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./VisitorStatisticsList.vue?vue&type=style&index=0&id=236bd862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236bd862",
  null
  
)

export default component.exports